module.exports = __webpack_public_path__ + "img/MACS-Logo.51ac0154.png";